import { GetChatMessagesQuery } from './queries.generated'
import { isHiddenSyntheticMessage } from './oracleSyntheticMessage'

// Helper: checks if all message pairs are oracle_begin pairs with no visible content
export const hasOnlyEmptyOracleBeginPairs = (
  messages: GetChatMessagesQuery['oracleMessagePairList']['oracleMessagePairs'],
): boolean => {
  if (messages.length === 0) return true
  return messages.every(
    (pair) => isHiddenSyntheticMessage(pair.userMessage.content)
      && !pair.oracleMessage.content?.trim()
      && !pair.documents?.some((doc) => doc.oracle),
  )
}
